import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasVerifiedEmail } from '../utils/platformAccess';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, token, isProfileComplete, user } = useAuth();
  const location = useLocation();
  const isProfileSetup = location.pathname === '/profile-setup';
  const isAcceptLegal = location.pathname === '/accept-legal';
  const isVerifyEmail = location.pathname === '/verify-email';

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (isProfileSetup || isAcceptLegal) {
    return token ? <Outlet /> : <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!hasVerifiedEmail(user) && !isProfileSetup && !isAcceptLegal && !isVerifyEmail) {
    return <Navigate to="/verify-email" replace />;
  }

  if (!isProfileComplete && !isVerifyEmail) {
    return <Navigate to="/profile-setup" replace />;
  }

  if (user?.needsLegalAcceptance) {
    return <Navigate to="/accept-legal" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
